import React from 'react';
import { Clickable, P } from '@fashionnovateam/nova-ui-toolkit';
import { ProductCellProps } from '../types';

export function ProductCell({
  styleName,
  styleColor,
  onClick,
}: ProductCellProps) {
  return (
    <Clickable
      className="h-full w-full flex items-center justify-start"
      onClick={onClick}
    >
      <div className="flex flex-col items-start">
        <P size="sm" weight="medium" className="truncate text-left">
          {styleName || '-'}
        </P>
        <P size="2xs" color="disabled" className="truncate text-left">
          {styleColor || '-'}
        </P>
      </div>
    </Clickable>
  );
}
